import { useState } from "react";
import { ReactSortable } from "react-sortablejs";
import classNames from "classnames";
import Token from "./Token";
import styles from "./formulaEditor.module.css";

const FormulaEditor = ({
  constants,
  tokens,
  onChange,
  parameters,
  getPrice,
}) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleDelete = (id) => onChange(tokens.filter((t) => t.id !== id));

  return (
      <div
        className={classNames(
          styles.formulaEditor,
          { [styles.errorInFormula]: getPrice({ parameters }).error },
          "formula-dragging-" + (isDragging ? "on" : "off") // global class switch
        )}
      >
        <ReactSortable
          list={tokens}
          setList={onChange}
          animation={150}
          swapThreshold={0.5}
          forceFallback={true}
          className={styles.sortable}
          filter="[data-nodrag]"
          preventOnFilter={true}
          onStart={() => setIsDragging(true)}
          onEnd={() => setIsDragging(false)}
        >
          {tokens.map((token) => (
            <div key={token.id} className={styles.itemWrapper}>
              <Token
                token={token}
                constants={constants}
                onDelete={() => handleDelete(token.id)}
              />
            </div>
          ))}
        </ReactSortable>
      </div>
  );
};

export default FormulaEditor;
